export const enum CONFIG_ANIM_TIME {
  SHORT = 200,
  MEDIUM = 400,
  LONG = 500,
  ONE_SECOND = 1000,
  TWO_SECONDS = 2000,
  THREE_SECONDS = 3000,
  HALF_MINUTE = 30000,
}

export const HOME_PAGE_DYNAMIC_CONTENT_KEY = {
  MENDEN: 'menden',
  HAMM: 'hamm',
  ISERLOHN: 'iserlohn',
  ARNSBERG: 'arnsberg',
  LUENEN: 'luenen',
  SOEST: 'soest',
  BERGKAMEN: 'bergkamen',
  BONEN: 'bonen',
  DORTMUND: 'dortmund',
  FROENDENBERG: 'froendenberg',
  HOLZWICKEDE: 'holzwickede',
  KAMEN: 'kamen',
};

export const scriptSchemaHamm = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Was kostet ein Immobilienmakler in Hamm?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Maklerprovision ist in Deutschland gesetzlich geregelt und wird in der Regel zwischen Käufer und Verkäufer aufgeteilt. Die Provision kann je nach individueller Vereinbarung variieren. Bei einer Vermietung ist die Provision vom Vermieter zu tragen, da das Bestellerprinzip gilt. Die Kosten lohnen sich jedoch, da ein Makler den bestmöglichen Preis erzielt und den gesamten Prozess professionell begleitet.',
      },
    },
    {
      '@type': 'Question',
      name: 'Warum sollte ich einen Makler beauftragen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein erfahrener Immobilienmakler übernimmt alle wichtigen Schritte im Verkaufs- oder Vermietungsprozess. Dazu gehören die marktgerechte Wertermittlung, eine professionelle Vermarktungsstrategie, die Organisation von Besichtigungen und die rechtssichere Vertragsabwicklung. Durch die Expertise eines Maklers erzielen Verkäufer oft einen höheren Verkaufspreis, vermeiden rechtliche Fallstricke und sparen wertvolle Zeit.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wie lange dauert es, eine Immobilie in Hamm zu verkaufen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Dauer eines Immobilienverkaufs hängt von verschiedenen Faktoren wie Lage, Preisgestaltung und Marktnachfrage ab. In begehrten Lagen kann ein Verkauf bereits innerhalb weniger Wochen abgeschlossen sein. Durch eine zielgerichtete Vermarktung, die Nutzung professioneller Netzwerke und eine realistische Preisbewertung kann ein Makler den Verkaufsprozess erheblich beschleunigen.',
      },
    },
  ],
};

export const scriptSchemaIserlohn = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Wie läuft der Verkaufsprozess mit einem Immobilienmakler ab?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein Immobilienmakler begleitet Sie durch alle Phasen des Verkaufs. Zunächst wird eine professionelle Wertermittlung durchgeführt, gefolgt von der Vermarktung auf relevanten Plattformen. Nach der Koordination von Besichtigungsterminen übernimmt der Makler die Preisverhandlungen und begleitet Sie bis zum notariellen Vertragsabschluss. So stellen Sie sicher, dass Sie einen optimalen Verkaufspreis erzielen und der gesamte Prozess effizient und rechtssicher abläuft.',
      },
    },
    {
      '@type': 'Question',
      name: 'Welche Unterlagen werden für den Immobilienverkauf benötigt?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Für einen reibungslosen Verkauf sollten wichtige Dokumente bereitliegen, darunter der Grundbuchauszug, ein aktueller Energieausweis, Baupläne sowie Nachweise über Modernisierungen. Ein Immobilienmakler hilft Ihnen, alle erforderlichen Unterlagen zu beschaffen. Fehlende Dokumente können den Verkaufsprozess verzögern – mit professioneller Unterstützung sind Sie bestens vorbereitet.',
      },
    },
    {
      '@type': 'Question',
      name: 'Kann ich meine Immobilie auch ohne Makler verkaufen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ja, ein Verkauf ohne Makler ist möglich, jedoch oft mit mehr Aufwand und Risiken verbunden. Ein Makler übernimmt nicht nur die Wertermittlung und Vermarktung, sondern sorgt auch für rechtssichere Verträge und einen reibungslosen Ablauf, um Fehler und finanzielle Einbußen zu vermeiden. Gerade in einem dynamischen Markt kann eine falsche Preisstrategie zu längeren Verkaufszeiten oder einem niedrigeren Erlös führen.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wann ist der beste Zeitpunkt, eine Immobilie in Iserlohn zu verkaufen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Der ideale Verkaufszeitpunkt hängt von Marktentwicklung, Nachfrage und Zinssituation ab. Ein Immobilienmakler kann Sie beraten, wann Ihre Immobilie den besten Preis erzielt und ob sich ein Verkauf aktuell lohnt. Markttrends ändern sich regelmäßig – eine professionelle Einschätzung hilft, den richtigen Moment für den Verkauf nicht zu verpassen.',
      },
    },
  ],
};

export const scriptSchemaArnsberg = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Was kostet ein Immobilienmakler in Arnsberg beim Verkauf?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Kosten für einen Immobilienmakler richten sich nach verschiedenen Faktoren – etwa dem Umfang der Leistungen, der Art der Immobilie und der individuellen Vereinbarung zwischen Verkäufer und Makler. In vielen Fällen wird die Maklerprovision beim Verkauf zwischen Käufer und Verkäufer aufgeteilt. Bei Beckschulte Immobilien-Management erhalten Sie eine transparente und faire Kostenübersicht – natürlich vorab und ohne versteckte Gebühren. Sprechen Sie uns einfach an, wir beraten Sie gerne unverbindlich.',
      },
    },
    {
      '@type': 'Question',
      name: 'Welche Vorteile bietet ein Immobilienmakler in Arnsberg gegenüber dem Privatverkauf?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein qualifizierter Immobilienmakler kennt den lokalen Markt in Arnsberg genau, ermittelt den realistischen Verkaufspreis, erstellt ein professionelles Exposé, übernimmt Besichtigungen und führt Verhandlungen. So sparen Sie Zeit, vermeiden rechtliche Risiken und erzielen in der Regel einen besseren Preis. Mit Beckschulte Immobilien profitieren Sie zusätzlich von persönlicher Betreuung und langjähriger Erfahrung im Sauerland.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wie schnell lässt sich eine Immobilie in Arnsberg verkaufen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Vermarktungsdauer hängt von Lage, Zustand und Preisgestaltung ab. In gefragten Arnsberger Stadtteilen wie Neheim, Bruchhausen oder Hüsten kann ein Verkauf oft innerhalb weniger Wochen erfolgen. Eine realistische Bewertung, zielgruppengerechte Präsentation und strukturierte Vermarktung beschleunigen den Prozess deutlich – dafür sorgen wir mit Erfahrung und System.',
      },
    },
  ],
};

export const scriptSchemaLuenen = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Welche Vorteile hat es, einen lokalen Makler in Lünen zu beauftragen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein ortskundiger Makler kennt nicht nur aktuelle Immobilienpreise, sondern auch die kleinen Unterschiede zwischen Stadtteilen wie Gahmen, Wethmar oder Lünen-Süd. Er kann realistisch einschätzen, wie sich Lage, Infrastruktur und Nachbarschaft auf den Verkauf oder die Vermietung auswirken. Zudem profitieren Sie von kurzen Wegen, persönlicher Erreichbarkeit und einer Vermarktung, die auf die lokalen Gegebenheiten abgestimmt ist.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wann ist der beste Zeitpunkt, um in Lünen eine Immobilie zu verkaufen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Der optimale Verkaufszeitpunkt hängt von verschiedenen Faktoren ab – z. B. Zinssituation, Marktnachfrage und Saisonverlauf. In Lünen beobachten wir eine konstant solide Nachfrage, insbesondere bei Einfamilienhäusern und gut angebundenen Wohnungen. Eine fundierte Marktanalyse hilft, die richtige Entscheidung zu treffen. Wir beraten Sie ehrlich und individuell, wann ein Verkauf für Sie sinnvoll ist.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wie läuft eine Immobilienbewertung in Lünen ab?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Zunächst besichtigen wir Ihre Immobilie vor Ort und analysieren Lage, Zustand, Ausstattung und Vergleichswerte im Umfeld. Dazu nutzen wir aktuelle Daten zu Bodenrichtwerten und realen Verkaufspreisen in Lünen. Das Ergebnis ist eine realistische und nachvollziehbare Einschätzung – als Grundlage für Vermarktung oder Entscheidungsfindung.',
      },
    },
  ],
};

export const scriptSchemaSoest = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Wie finde ich den passenden Makler für meine Immobilie in Soest?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Achten Sie bei der Maklerwahl in Soest nicht nur auf schöne Versprechen, sondern auf Erfahrung, regionale Marktkenntnis und transparente Kommunikation. Ein guter Immobilienmakler nimmt sich Zeit für Ihre Fragen, kennt die lokalen Besonderheiten – etwa im Bereich Denkmalschutz in der Altstadt oder Neubaugebiete in Soest-Ost – und arbeitet strukturiert. Bei Beckschulte Immobilien setzen wir auf persönliche Beratung, nachvollziehbare Prozesse und messbare Ergebnisse.',
      },
    },
    {
      '@type': 'Question',
      name: 'Was muss ich beim Hausverkauf in Soest beachten?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Jede Stadt hat ihre Eigenheiten – auch Soest. Beim Hausverkauf spielen Faktoren wie der Bodenrichtwert, die Energieeffizienz des Gebäudes, rechtliche Vorgaben und der optimale Zeitpunkt eine große Rolle. Insbesondere in historisch geprägten Vierteln oder bei ländlichen Lagen im Umland ist eine fachkundige Bewertung entscheidend. Wir unterstützen Sie dabei, alle Rahmenbedingungen zu klären – damit der Verkauf reibungslos verläuft.',
      },
    },
    {
      '@type': 'Question',
      name: 'Welche Rolle spielt die Lage innerhalb von Soest beim Immobilienverkauf?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Lage ist ein entscheidender Faktor für den Immobilienwert – auch in Soest. Ob Altstadt mit Fachwerkcharme, die Nähe zum Bahnhof, gute Anbindung an die B1 oder ruhige Wohnlagen in Soest-Bergede: Jede Mikro-Lage spricht unterschiedliche Käufergruppen an. Wir analysieren genau, welches Potenzial Ihre Immobilie bietet und richten die Vermarktung gezielt darauf aus. So steigern wir die Erfolgschancen und sprechen genau die richtigen Interessenten an.',
      },
    },
  ],
};

export const scriptSchemaBergkamen = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Was macht ein Immobilienmakler genau?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein Immobilienmakler vermittelt zwischen Verkäufern und Käufern bzw. Vermietern und Mietern. Er bewertet Immobilien, erstellt Exposés, organisiert Besichtigungen, prüft Interessenten, führt Verhandlungen und begleitet den Verkaufsprozess bis zum Notartermin. Zudem übernimmt er Marketing, Marktanalysen und sorgt für rechtliche sowie organisatorische Sicherheit im gesamten Transaktionsablauf.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wie hoch ist die Maklerprovision in Deutschland?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Maklerprovision in Deutschland liegt beim Immobilienverkauf meist zwischen 3 % und 7 % des Kaufpreises zuzüglich Mehrwertsteuer. Seit 2020 gilt: Bei Wohnimmobilien teilen sich Käufer und Verkäufer die Provision in der Regel zu gleichen Teilen. Die genaue Höhe variiert je nach Bundesland und individueller Vereinbarung.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wie lange dauert es, eine Immobilie zu verkaufen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Dauer eines Immobilienverkaufs beträgt im Durchschnitt etwa 3 bis 6 Monate. Sie hängt von Faktoren wie Lage, Preisgestaltung, Zustand der Immobilie und Marktnachfrage ab. In gefragten Regionen kann der Verkauf schneller erfolgen, während es in schwächeren Märkten deutlich länger dauern kann.',
      },
    },
  ],
};

export const scriptSchemaBonen = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Warum ist ein lokaler Immobilienmakler von Vorteil?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein lokaler Immobilienmakler kennt den regionalen Markt sehr genau, inklusive Preise, Nachfrage und Zielgruppen. Er verfügt über ein Netzwerk aus Interessenten, Handwerkern und Notaren. Dadurch kann er Immobilien realistischer bewerten, schneller vermitteln und gezielter vermarkten, was oft zu besseren Verkaufspreisen und kürzeren Vermarktungszeiten führt.',
      },
    },
    {
      '@type': 'Question',
      name: 'Welche Unterlagen werden für den Verkauf benötigt?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Für den Immobilienverkauf werden unter anderem Grundbuchauszug, Energieausweis, Grundrisse, Wohnflächenberechnung, Baupläne, Flurkarte sowie ggf. Teilungserklärung und Protokolle der Eigentümerversammlung benötigt. Zusätzlich sind Angaben zu Modernisierungen, Nebenkosten und bei Häusern oft Baujahr und technische Details erforderlich, um Käufern vollständige Transparenz zu bieten.',
      },
    },
    {
      '@type': 'Question',
      name: 'Woran erkenne ich einen seriösen Immobilienmakler?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Einen seriösen Makler erkennt man an transparenter Kommunikation, realistischer Preisbewertung und klaren Vertragsbedingungen. Er verfügt über Referenzen, regionale Marktkenntnis und eine gültige Gewerbeerlaubnis. Zudem drängt er nicht zu schnellen Entscheidungen, informiert umfassend und arbeitet strukturiert sowie nachvollziehbar im Interesse seines Kunden.',
      },
    },
  ],
};

export const scriptSchemaDortmund = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Wie läuft der Verkauf einer Immobilie mit Makler ab?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Der Verkaufsprozess beginnt mit der Bewertung der Immobilie und der Festlegung eines marktgerechten Preises. Anschließend erstellt der Makler ein Exposé, vermarktet die Immobilie, organisiert Besichtigungen, prüft Interessenten und führt Preisverhandlungen. Nach Einigung begleitet er Käufer und Verkäufer bis zum Notartermin und der finalen Übergabe.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wer zahlt den Immobilienmakler?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'In Deutschland zahlen beim Verkauf von Wohnimmobilien in der Regel Käufer und Verkäufer jeweils einen Teil der Maklerprovision. Seit der gesetzlichen Neuregelung 2020 darf der Käufer maximal genauso viel zahlen wie der Verkäufer. Bei Vermietungen übernimmt meist der Auftraggeber, also der Vermieter, die Maklerkosten vollständig.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wie gut kennt ein Makler den Immobilienmarkt?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein professioneller Immobilienmakler verfügt über fundierte Marktkenntnisse, da er regelmäßig mit regionalen Angeboten, Preisen und Entwicklungen arbeitet. Er analysiert Vergleichsobjekte, kennt Nachfrage und Trends und kann realistische Preiseinschätzungen geben. Gute Makler beobachten kontinuierlich den Markt und passen ihre Strategien entsprechend den aktuellen Bedingungen an.',
      },
    },
  ],
};

export const scriptSchemaFroendenberg = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Wann lohnt es sich, einen Immobilienmakler zu beauftragen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein Immobilienmakler lohnt sich besonders, wenn wenig Marktkenntnis vorhanden ist, Zeit fehlt oder ein optimaler Verkaufspreis erzielt werden soll. Auch bei komplexen Objekten, rechtlichen Unsicherheiten oder emotionalen Verkäufen bietet ein Makler klare Vorteile durch Erfahrung, Verhandlungsgeschick und professionelle Vermarktung.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wie wird der Wert meiner Immobilie vor Ort ermittelt?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Der Immobilienwert wird vor Ort durch Besichtigung und Analyse verschiedener Faktoren ermittelt: Lage, Zustand, Ausstattung, Größe und Baujahr. Zusätzlich vergleicht der Makler ähnliche Objekte, nutzt Bewertungsverfahren und berücksichtigt aktuelle Marktdaten, um einen realistischen und marktgerechten Angebotspreis festzulegen.',
      },
    },
    {
      '@type': 'Question',
      name: 'Welche Fragen sollte ich einem Makler vor der Beauftragung stellen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Vor der Beauftragung sollten Fragen zu Erfahrung, Referenzen, Vermarktungsstrategie und regionaler Marktkenntnis gestellt werden. Wichtig sind auch Informationen zur Provision, Vertragslaufzeit und Erreichbarkeit. Zudem sollte geklärt werden, wie die Preisbewertung erfolgt und welche konkreten Leistungen im Service enthalten sind.',
      },
    },
  ],
};

export const scriptSchemaHolzwickede = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Wie findet ein Makler den richtigen Käufer für meine Immobilie?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein Makler findet den passenden Käufer durch gezielte Vermarktung über Online-Portale, eigene Kundendatenbanken und Netzwerke. Er filtert Interessenten vor, prüft Bonität und Bedürfnisse und spricht gezielt passende Zielgruppen an. Durch Erfahrung erkennt er schnell ernsthafte Käufer und führt strukturierte Besichtigungen sowie Verhandlungen durch.',
      },
    },
    {
      '@type': 'Question',
      name: 'Ist die Provision verhandelbar oder gesetzlich festgelegt?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Maklerprovision ist in Deutschland grundsätzlich frei verhandelbar und nicht gesetzlich festgelegt. Es existieren jedoch regionale Üblichkeiten, an denen sich viele Makler orientieren. Seit 2020 gilt bei Wohnimmobilien, dass Käufer maximal denselben Anteil zahlen wie Verkäufer, was die Verteilung, nicht aber die Höhe begrenzt.',
      },
    },
    {
      '@type': 'Question',
      name: 'Sollte ich mehrere Makler vergleichen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Es ist sinnvoll, mehrere Makler zu vergleichen, um Leistungen, Erfahrung und Vermarktungsstrategien zu bewerten. Unterschiede zeigen sich oft bei Preisansätzen, Serviceumfang und Engagement. Ein Vergleich hilft, den passenden Partner zu finden, sollte aber nicht nur auf die niedrigste Provision, sondern auf Qualität und Kompetenz abzielen.',
      },
    },
  ],
};

export const scriptSchemaKamen = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Welche Leistungen übernimmt ein Makler beim Hausverkauf?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein Makler übernimmt beim Hausverkauf die komplette Abwicklung: Wertermittlung, Erstellung professioneller Exposés, Vermarktung, Koordination und Durchführung von Besichtigungen, Bonitätsprüfung der Interessenten, Verhandlungsführung sowie Vorbereitung des Kaufvertrags. Zudem begleitet er den gesamten Prozess bis zum Notartermin und sorgt für einen reibungslosen Ablauf.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wie wird meine Immobilie optimal vermarktet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Eine optimale Vermarktung erfolgt durch hochwertige Fotos, aussagekräftige Exposés und gezielte Platzierung auf Immobilienportalen. Ergänzend nutzt der Makler sein Netzwerk, Social Media und vorgemerkte Interessenten. Die Ansprache wird auf die Zielgruppe abgestimmt, um maximale Sichtbarkeit und Nachfrage zu erzeugen.',
      },
    },
    {
      '@type': 'Question',
      name: 'Kann ein Makler einen höheren Verkaufspreis erzielen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein erfahrener Makler kann häufig einen höheren Verkaufspreis erzielen, da er den Markt genau kennt und den Angebotspreis strategisch festlegt. Durch professionelle Präsentation, gezielte Nachfragegenerierung und Verhandlungsgeschick wird Wettbewerb geschaffen, was sich positiv auf den finalen Verkaufspreis auswirken kann.',
      },
    },
  ],
};
